import http from '@libs/http';
import {
  AgreementApproveResponse,
  AgreementAttachment,
  AgreementQuery,
  CustomersClub,
  ReleaseNotesQuery,
  User,
} from '@libs/api-reference';

import { TSE_API } from './endpoints';

export enum ReleaseNoteSystemType {
  'Next' = 1,
  'Helium' = 2,
}

export function getUserInfo() {
  return http.get<User>(`${TSE_API}/users/me`, {
    schema: User,
    cancellable: false,
  });
}

export function getUserBankAccounts() {
  return http.get(`${TSE_API}/personage/bankaccounts`);
}

export function getUserAgreements() {
  return http.get<AgreementQuery>(`${TSE_API}/agreements`, {
    schema: AgreementQuery,
  });
}

export function getAgreementText(id: number) {
  return http.get<AgreementAttachment>(`${TSE_API}/agreements/{id}`, {
    urlParams: { id },
    schema: AgreementAttachment,
  });
}

export function approveAgreement({
  id,
  approve,
}: {
  id: number;
  approve: boolean;
}) {
  return http.put<AgreementApproveResponse>(
    `${TSE_API}/agreements/{id}/toggle`,
    { approve },
    {
      urlParams: { id },
      schema: AgreementApproveResponse,
    }
  );
}

export function getReleaseNotes(system: ReleaseNoteSystemType) {
  return http.get<ReleaseNotesQuery>(`${TSE_API}/changelogs/{system}`, {
    urlParams: { system },
    schema: ReleaseNotesQuery,
  });
}

export function getCustomersClubInfo() {
  return http.get<CustomersClub>(`${TSE_API}/customerclubs`, {
    schema: CustomersClub,
  });
}
